<template>
  <div class="row m-0 align-items-center h-100">
    <!--MOBILE NAV ICON-->
    <div class="col-auto p-0 d-lg-none">
      <div class="row m-0 h-100 align-items-center">
        <div class="menu_icon">
          <div @click="toggleNavbar" class="above_all cursor text-center" v-if="currentUser">
            <ios-menu-icon v-if="isNavOpen" class="ninety_degree dark_text" />
            <ios-menu-icon v-else/>
          </div>
          <div @click="goTo('/landing')" class="above_all cursor text-center" v-else-if="$route.name == 'Help' || $route.name == 'Privacy' || $route.name == 'Terms' || $route.name == 'Register' || $route.name == 'Login'">
            <ios-arrow-back-icon />
          </div>
        </div>
      </div>
    </div>
    <!--END MOBILE NAV ICON-->
    <!-- <div class="col-auto p-0 d-lg-none" v-if="$route.name == 'Help' || $route.name == 'Privacy' || $route.name == 'Terms'">
      <div class="row m-0 h-100 align-items-center">
        <div class="menu_icon">
          <div @click="goTo('/landing')" class="above_all cursor text-center">
            <ios-arrow-back-icon />
          </div>
        </div>
      </div>
    </div> -->
    <!--TOP MENU ITEMS-->
    <div class="col p-0">
      <div class="row m-0 align-items-center">
        <div class="col-12 col-md-auto col-lg-3 col-xl-2 text-center text-md-start cursor" @click="goTo('/')" v-if="currentUser">
          <img src="../../assets/images/logo_white.png" class="logo"/>
        </div>
        <div class="col-auto col-md-auto col-lg-3 col-xl-2 text-start cursor" @click="goTo('/landing')" v-else>
          <img src="../../assets/images/logo_white.png" class="logo"/>
        </div>
        <div class="col">
          <div class="row m-0 justify-content-end align-items-center d-none d-md-flex" v-if="currentUser">
            <!-- <div class="col p-0 cursor">
              <search-menu></search-menu>
            </div> -->
            <div class="col-auto p-0 cursor">
              <!-- {{currentUser}} -->
              <!-- <div v-if="!isLoggedIn" @click="login" class="pb-1">
                Login
              </div>
              <profile-menu :user="currentUser" v-else></profile-menu> -->
              <profile-menu v-if="currentUser"></profile-menu>
            </div>
          </div>
          <div class="row m-0 justify-content-end align-items-center" v-else>
            <div class="col-auto p-3 cursor bold" @click="help()">
              Help
            </div>
            <div class="col-auto p-0 p-md-3 cursor bold" @click="goTo('/register')" v-if="!currentUser">
              Register
            </div>
            <div class="col-auto p-0 p-md-3 cursor bold" @click="goTo('/login')" v-if="!currentUser">
              Login
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--END TOP MENU ITEMS-->
    <div class="col-auto p-0 d-lg-none transparent" v-if="currentUser">
      <div class="row m-0 h-100 align-items-center">
        <div class="menu_icon">
          <div @click="toggleNavbar" class="above_all cursor text-center">
            <ios-menu-icon v-if="isNavOpen" class="ninety_degree dark_text" />
            <ios-menu-icon v-else/>
          </div>
        </div>
      </div>
    </div>
    <!--MOBILE MENU-->
    <transition name="slide">
      <div v-if="isNavOpen" class="mobile_menu">
        <main-menu @close="closeNav" :currentPage="currentPage" @scrollto="scrollto"></main-menu>
      </div>
    </transition>
    <!--END MOBILE MENU -->
    <!--DESKTOP MENU-->
    <div class="desktop_menu d-none d-lg-block" v-if="(currentUser || $route.name == 'Help' || $route.name == 'Privacy' || $route.name == 'Terms') && $route.name !== 'Landing'">
      <main-menu :currentPage="currentPage" @scrollto="scrollto"></main-menu>
    </div>
    <!--END DESKTOP MENU -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {
    'profile-menu': () => import('./ProfileMenuHolder.vue'),
    'main-menu': () => import('./MainMenu.vue')
    // 'search-menu': () => import('./Search.vue')
  },
  props: {
    currentPage: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      isNavOpen: false,
      isScrolled: false
    }
  },
  // beforeMount () {
  //   window.addEventListener('scroll', this.handleScroll)
  // },
  // beforeDestroy () {
  //   window.removeEventListener('scroll', this.handleScroll)
  // },
  computed: {
    ...mapGetters(['isLoggedIn', 'currentUser', 'theUser'])
  },
  methods: {
    // ...mapActions(['logout']),
    toggleNavbar () {
      this.isNavOpen = !this.isNavOpen
    },
    closeNav () {
      this.isNavOpen = false
    },
    help () {
      window.open('https://www.rememberblue.com/help')
    },
    goTo (val) {
      window.scrollTo(0, 0)
      this.$router.push(val)
    },
    scrollto (val) {
      this.$emit('scrollto', val)
    }
  }
}
</script>

<style scoped>
.logo {
  max-width: 100%;
  max-height: 50px;
}
.mobile_menu {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 999;
  background-color: transparent;
  color: var(--darkblue);
  padding: 0;
}
.mobile_menu .nav-link {
  display: block;
  padding: 0;
}
.close_icon {
  position: absolute;
  left: 17px;
  top: 17px;
  width: 25vw;
  text-align: left;
}
.desktop_menu {
  position: fixed;
  top: 70px;
  left: 0;
  height: calc(100vh - 70px);
  width: 25vw;
  z-index: 999;
  background-color: #fff;
  color: var(--darkblue);
  overflow-y: auto;
}
.full_height {
  height: 100vh;
}
.above_all {
  z-index: 9999;
  position: relative;
}
.ninety_degree {
  transform: rotate(90deg);
}
.menu_icon {
  width: 44px;
  height: 44px;
  text-align: center;
  border-radius: 50%;
  padding: 7px;
}
.truncate {
  word-wrap: break-word;
  overflow-y: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 1;
}
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter {
  transform: translateX(-100%);
  opacity: 1;
}
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 1;
}
.transparent {
  opacity: 0;
}
@media (min-width: 992px) {
  .desktop_menu {
    width: 25vw;
  }
}
@media (min-width: 1200px) {
  .desktop_menu {
    width: 16.6vw;
  }
}
</style>
